import { useEffect } from "react";

import { useEnv } from "./useEnv";

/**
 * Retitle the browser tab "{displayName} | {label}" while a screen is mounted,
 * restoring the app default ("{displayName} | Portal") on unmount. Mirrors the
 * per-loan title effect in LoanDrilldownScreen — the global title effect in
 * index.js only re-runs on displayName change, so each screen that wants a tab
 * label sets it here.
 */
export const useDocumentTitle = (label) => {
  const { displayName } = useEnv();

  useEffect(() => {
    document.title = label ? `${displayName} | ${label}` : `${displayName} | Portal`;
    return () => {
      document.title = `${displayName} | Portal`;
    };
  }, [label, displayName]);
};

export default useDocumentTitle;
